export default function runningInCypressTest() {
  return !!window.Cypress;
}
